import Vue from 'vue'
import Router from 'vue-router'
import mainLiao from '@/components/mainLiao'
import fabrication from '@/components/fabrication'
import center from '@/components/center'
import login from '@/components/login'
import redirect from '@/components/redirect'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '我的料',
      component: mainLiao
    },
    {
      path: '/mainLiao',
      name: '我的料',
      component: mainLiao
    },
    {
      path: '/datacode',
      name: '料码页面',
      component: () => import('@/components/datacode')
    },
    {
      path: '/buyed',
      name: '料码页面',
      component: () => import('@/components/buyed')
    },
    {
      path: '/editarticle',
      name: '编辑料',
      component: () => import('@/components/editarticle')
    },
    {
      path: '/makearticle',
      name: '详情',
      component: () => import('@/components/makearticle')
    },
    {
      path: '/topic',
      name: '专辑制作',
      component: () => import('@/components/topic')
    },
    {
      path: '/fabrication',
      name: '制作料',
      component: fabrication
    },
    {
      path: '/center',
      name: '我的',
      component: center
    },
    {
      path: '/center/setmuthhome',
      name: '主页设置',
      component: () => import('@/components/center/setmuthhome')
    },
    {
      path: '/center/rechargeDetail',
      name: '充值明细',
      component: () => import('@/components/center/rechargeDetail')
    },
    {
      path: '/center/followList',
      name: '关注列表',
      component: () => import('@/components/center/followList')
    },
    {
      path: '/center/setContentBackground',
      name: '内容背景设置',
      component: () => import('@/components/center/setContentBackground')
    },
    {
      path: '/center/recharge',
      name: '充值',
      component: () => import('@/components/center/recharge')
    },
    {
      path: '/center/revenue',
      name: '收入明细',
      component: () => import('@/components/center/revenue')
    },
    {
      path: '/center/withdrawal',
      name: '提现列表',
      component: () => import('@/components/center/withdrawal')
    },
    {
      path: '/center/goTx',
      name: '提现',
      component: () => import('@/components/center/goTx')
    },
    {
      path: '/center/setting',
      name: '个人设置',
      component: () => import('@/components/center/setting')
    },
    {
      path: '/center/muthhome',
      name: '主页',
      component: () => import('@/components/center/muthhome')
    },
    {
      path: '/center/myfanslist',
      name: '粉丝列表',
      component: () => import('@/components/center/myfanslist')
    },
    {
      path: '/center/consumeDetail',
      name: '粉丝消费列表',
      component: () => import('@/components/center/consumeDetail')
    },
    {
      path: '/center/setBackground',
      name: '背景设置',
      component: () => import('@/components/center/setBackground')
    },
    {
      path: '/mine/promotionauthor',
      name: '设置推广',
      component: () => import('@/components/mine/promotionauthor')
    },
    {
      path: '/weixinpay',
      name: '微信支付',
      component: () => import('@/components/weixinpay')
    },
    {
      path: '/zhifubaopay',
      name: '支付宝支付',
      component: () => import('@/components/zhifubaopay')
    },
    {
      path: '/login',
      name: '登录',
      component: login
    },
    {
      path: '/redirect',
      name: '授权回调',
      component: redirect
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js